export default __webpack_public_path__ + "static/media/drag-and-drop-icon.dac5b169.svg";